import { translation, TranslatedComponent } from '@hh.ru/front-static-app';

import styles from './styles.less';

const TrlKeys = {
    annotation: 'career-platform.profession.main.annotation',
};

const MainAnnotation: TranslatedComponent = ({ trls }) => <p className={styles.text}>{trls[TrlKeys.annotation]}</p>;

export default translation(MainAnnotation);
